module.exports = __webpack_public_path__ + "img/1737080344531-Screenshot 96.png.7b1c189a.webp";